import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteManyCarrierContactActions } from 'store/ducks/settings/carrier-contact';

export function* deleteManyCarrierContactRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carrier-contact/delete`,
      putData
    );

    const { data } = responseBody;
    yield put(DeleteManyCarrierContactActions.success(data));
    notify('success', 'Contatos deletados com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteManyCarrierContactActions.failure(errorMessage));
  }
}
